<template>
  <div class="container">
    <button type="button" @click.prevent="addUnit">Add Units</button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      units: [
        { unitId: 'KPNG', unitTitle: 'Motion: Pushes and Pulls', unitSort: '0', unitQty: '0', orderBy: '0PNG' },
        { unitId: 'KLNG', unitTitle: 'Plants and Animals Live Here', unitSort: '0', unitQty: '0', orderBy: '0LNG' },
        { unitId: 'KENG', unitTitle: 'Weather and Climate', unitSort: '0', unitQty: '0', orderBy: '0ENG' },
        { unitId: '1PNG', unitTitle: 'Waves: Light and Sound', unitSort: '1', unitQty: '0', orderBy: '1PNG' },
        { unitId: '1LNG', unitTitle: 'Plant and Animal Traits', unitSort: '1', unitQty: '0', orderBy: '1LNG' },
        { unitId: '1ENG', unitTitle: 'Space Systems: Patterns and Cycles', unitSort: '1', unitQty: '0', orderBy: '1ENG' },
        { unitId: '2PNG', unitTitle: 'Structure and Properties of Matter', unitSort: '2', unitQty: '0', orderBy: '2PNG' },
        { unitId: '2LNG', unitTitle: 'Plant and Animal Relationships', unitSort: '2', unitQty: '0', orderBy: '2LNG' },
        { unitId: '2ENG', unitTitle: 'Changing Earth: Today and Over Time', unitSort: '2', unitQty: '0', orderBy: '2ENG' },
        { unitId: '3PNG', unitTitle: 'Forces and Interactions', unitSort: '3', unitQty: '0', orderBy: '3PNG' },
        { unitId: '3LNG', unitTitle: 'Life Cycles and Survival in an Ecosystem', unitSort: '3', unitQty: '0', orderBy: '3LNG' },
        { unitId: '3ENG', unitTitle: 'Weather, Climate, and Natural Hazards', unitSort: '3', unitQty: '0', orderBy: '3ENG' },
        { unitId: '4PNG', unitTitle: 'Energy and Waves', unitSort: '4', unitQty: '0', orderBy: '4PNG' },
        { unitId: '4LNG', unitTitle: 'Structure, Function, and Information Processing', unitSort: '4', unitQty: '0', orderBy: '4LNG' },
        { unitId: '4ENG', unitTitle: 'Processes that Shape the Earth', unitSort: '4', unitQty: '0', orderBy: '4ENG' },
        { unitId: '5PNG', unitTitle: 'Structure and Properties of Matter', unitSort: '5', unitQty: '0', orderBy: '5PNG' },
        { unitId: '5LNG', unitTitle: 'Matter and Energy in an Ecosystem', unitSort: '5', unitQty: '0', orderBy: '5LNG' },
        { unitId: '5ENG', unitTitle: 'Earth and Space Systems', unitSort: '5', unitQty: '0', orderBy: '5ENG' },
        { unitId: 'MSPNG1', unitTitle: 'Forces: Contact and Non-Contact', unitSort: '6', unitQty: '0', orderBy: '6PNG1' },
        { unitId: 'MSPNG2', unitTitle: 'Particles of Matter and Chemical Reactions', unitSort: '6', unitQty: '0', orderBy: '6PNG2' },
        { unitId: 'MSPNG3', unitTitle: 'Energy and the Electromagnetic Spectrum', unitSort: '6', unitQty: '0', orderBy: '6PNG3' },
        { unitId: 'MSENG1', unitTitle: 'History of Earth', unitSort: '7', unitQty: '0', orderBy: '7ENG1' },
        { unitId: 'MSENG2', unitTitle: 'Weather, Climate, and Human Impact', unitSort: '7', unitQty: '0', orderBy: '7ENG2' }
      ]
    }
  },
  methods: {
    addUnit() {
      this.units.forEach((unit) => {
        fb.unitsCollection.add({
          unitId: unit.unitId,
          unitTitle: unit.unitTitle,
          unitQty: unit.unitQty,
          orderBy: unit.orderBy
        }).catch((err) => {
          console.log(err)
        })
      })
      // fb.unitsCollection.add({
      //   units.forEach(element => console.log(element))
      // })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
